import React, { useEffect, useState, useMemo } from "react";
import plusCircle from "../../assets/icons/plusCircle.svg";
import cross from "../../assets/icons/x-circle-3.svg";
import simpleRequest from "../../utils/helpers/simpleRequest";
import Xicon from "../../assets/icons/Xicon.svg";
import Plusicon from "../../assets/icons/Plus.svg";
import Bin from "../../assets/icons/TemplateBuilder/Bin.svg";
import calendar from "../../assets/icons/calendar.svg";
import AppDatePicker from "../../components/Common/AppDatePicker";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const AddWork = ({ setIsAddWork, isAddWork, fetchWorkList }) => {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [search, setSearch] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [users, setUsers] = useState([]);
  const [state, setState] = useState({
    workName: "",
    supervisor: { id: "", firstName: "", lastName: "", img: "" },
  });
  const [taskList, setTaskList] = useState([]);

  const { workName, supervisor } = state;

  const isDisabled = useMemo(() => {
    if (
      state?.workName &&
      state.supervisor?.firstName &&
      taskList?.length > 0 &&
      taskList.every((task) => task.taskName?.length > 0)
    )
      return false;
    else return true;
  }, [state, taskList]);

  const fetchActiveUsers = async () => {
    const resp = await simpleRequest(`/api/User/FetchActiveUsers`, "post", {
      companyid: window.localStorage.getItem("companyid"),
    });
    if (resp?.status === true) setUsers(resp?.data);
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    setState((sta) => ({ ...sta, [name]: value }));
  };

  const handleTaskChange = (name, value, index) => {
    const list = [...taskList];
    list[index][name] = value;
    setTaskList([...list]);
  };

  const handleDelete = (index) => {
    let list = Array.from(taskList);
    list.splice(index, 1);
    setTaskList([...list]);
  };

  const handleClear = () => {
    setTaskList([]);
    setState({
      workName: "",
      supervisor: { id: "", firstName: "", lastName: "", img: "" },
    });
    setIsAddWork(false);
    setIsAdding(false);
  };

  const handleAddWork = async () => {
    const list = new Array();
    taskList?.map((item) =>
      list.push({
        taskname: item?.taskName,
        startingDate: item?.startDate?.toISOString(),
        endDate: item?.endDate.toISOString(),
      })
    );
    const payload = {
      workname: state?.workName,
      supervisorid: state.supervisor.id,
      projectid: window.localStorage.getItem("projectid"),
      workTask: list,
    };
    const resp = await simpleRequest(`/api/User/AddWorkTask`, "post", payload);
    setIsAdding(true);
    if (resp?.status === true) {
      handleClear();
      fetchWorkList();
    } else setIsAdding(true);
  };

  useEffect(() => {
    fetchActiveUsers();
  }, []);

  return (
    <div
      className="team-add-work-box"
      style={{
        top: !isAddWork ? "-50px" : "0",
        visibility: !isAddWork ? "hidden" : "visible",
        opacity: !isAddWork ? 0 : 1,
        zIndex: !isAddWork ? -1 : 3,
      }}
    >
      <div className="frcb">
        <p className="team-add-work-heading">
          {/* Add Work */}
          {t("Add Work")}
        </p>
        <img src={cross} className="cursor-pointer" onClick={handleClear} />
      </div>
      <div className="frc mt-4" style={{ gap: "1rem" }}>
        <div className="st-single-stage-div" style={{ width: "100%" }}>
          <label className="st-single-stage-label">
            {/* Work Name */}
            {t("Work Name")}
          </label>
          <input
            className="reference-input"
            value={workName}
            onChange={handleChange}
            name="workName"
          />
        </div>
        <div className="st-single-stage-div" style={{ width: "100%" }}>
          <label className="st-single-stage-label">
            {/* Supervisor */}
            {t("Supervisor")}
          </label>
          <div style={{ position: "relative" }}>
            <div
              className="team-add-work-super-box"
              style={{
                top: !showSearch ? "-50px" : "-15px",
                visibility: !showSearch ? "hidden" : "visible",
                opacity: !showSearch ? 0 : 1,
              }}
            >
              <div className="team-add-work-topbar">
                <input
                  // placeholder="Search"
                  placeholder={t("Search")}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="team-add-super-search"
                />
              </div>
              <div className="team-add-work-userList">
                {users
                  ?.filter((x) =>
                    `${x.firstname} ${x.lastname}`
                      .toLowerCase()
                      .includes(search.toLowerCase()),
                  )
                  ?.map((user, index) => {
                    return (
                      <div
                        className="team-add-work-single-user-div frc"
                        key={index}
                        onClick={() => {
                          setState((sta) => ({
                            ...sta,
                            supervisor: {
                              firstName: user?.firstname,
                              lastName: user?.lastname,
                              img: user?.imageurl,
                              id: user?.userid,
                            },
                          }));
                          setSearch("");
                          setShowSearch(false);
                        }}
                      >
                        {user?.imageurl ? (
                          <img
                            src={user?.imageurl}
                            className="team-add-work-user-img"
                          />
                        ) : (
                          <div className="team-add-work-user-img">
                            {user?.firstname?.split("")?.[0]}
                            {user?.lastname?.split("")?.[0]}
                          </div>
                        )}
                        <p>
                          {user?.firstname} {user?.lastname}
                        </p>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          {supervisor?.firstName ? (
            <div className="frcb" style={{ width: "100%" }}>
              <div className="frc" style={{ gap: "0.5rem" }}>
                {supervisor?.img ? (
                  <img
                    src={supervisor?.img}
                    className="team-add-work-user-img"
                    style={{ width: "30px", height: "30px" }}
                  />
                ) : (
                  <div
                    className="team-add-work-user-img"
                    style={{ width: "30px", height: "30px", fontSize: "12px" }}
                  >
                    {supervisor?.firstName?.split("")?.[0]}
                    {supervisor?.lastName?.split("")?.[0]}
                  </div>
                )}
                <p className="sel-supervisor-name">
                  {supervisor?.firstName} {supervisor?.lastName}
                </p>
              </div>
              <img
                src={Xicon}
                className="cursor-pointer"
                onClick={() =>
                  setState((sta) => ({
                    ...sta,
                    supervisor: {
                      id: "",
                      firstName: "",
                      lastName: "",
                      img: "",
                    },
                  }))
                }
              />
            </div>
          ) : (
            <img
              src={plusCircle}
              className="cursor-pointer"
              onClick={() => setShowSearch(!showSearch)}
            />
          )}
        </div>
      </div>
      <div
        className="frcb"
        style={{ marginTop: "1rem", paddingRight: "0.5rem" }}
      >
        <p className="team-work-task-text">
          {/* Work Task */}
          {t("Work Task")}
        </p>
        <div
          className="frc cursor-pointer"
          style={{ gap: "0.5rem" }}
          onClick={() => {
            const list = Array.from(taskList);
            list.push({
              taskName: "",
              isStartDate: false,
              startDate: new Date(),
              isEndDate: false,
              endDate: new Date(),
            });
            setTaskList([...list]);
          }}
        >
          <p className="team-work-add-task-text">
            {/* Add */}
            {t("Add")}
          </p>
          <img src={Plusicon} style={{ width: "14px", height: "14px" }} />
        </div>
      </div>
      <div className="team-add-work-task-list">
        {taskList?.map((task, index) => {
          return (
            <div className="team-add-work-task-grid" key={index}>
              <div className="st-single-stage-div" style={{ width: "100%" }}>
                <label className="st-single-stage-label">
                  {/* Task Name */}
                  {t("Task Name")}
                </label>
                <input
                  className="reference-input"
                  value={task?.taskName}
                  onChange={(e) =>
                    handleTaskChange(e.target.name, e.target.value, index)
                  }
                  name="taskName"
                />
              </div>
              <div className="st-single-stage-div" style={{ width: "100%" }}>
                <label className="st-single-stage-label">
                  {/* Start Date */}
                  {t("Start Date")}
                </label>
                <div className="frc" style={{ columnGap: "0.25rem" }}>
                  <img
                    className="calendarIcon pointer"
                    onClick={() =>
                      handleTaskChange("isStartDate", !task?.isStartDate, index)
                    }
                    src={calendar}
                  />
                  <AppDatePicker
                    open={task.isStartDate}
                    selected={task.startDate}
                    onChange={(val) => {
                      handleTaskChange(
                        "isStartDate",
                        !task?.isStartDate,
                        index,
                      );
                      handleTaskChange("startDate", val, index);
                    }}
                    inputClassNames="font-size-medium"
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
              </div>
              <div className="st-single-stage-div" style={{ width: "100%" }}>
                <label className="st-single-stage-label">
                  {/* End Date */}
                  {t("End Date")}
                </label>
                <div className="frc" style={{ columnGap: "0.25rem" }}>
                  <img
                    className="calendarIcon pointer"
                    onClick={() =>
                      handleTaskChange("isEndDate", !task?.isEndDate, index)
                    }
                    src={calendar}
                  />
                  <AppDatePicker
                    open={task.isEndDate}
                    selected={task.endDate}
                    onChange={(val) => {
                      handleTaskChange("isEndDate", !task?.isEndDate, index);
                      handleTaskChange("endDate", val, index);
                    }}
                    dateFormat="dd/MM/yyyy"
                    inputClassNames="font-size-medium"
                  />
                </div>
              </div>
              <img
                src={Bin}
                style={{ justifySelf: "end", cursor: "pointer" }}
                onClick={() => handleDelete(index)}
              />
            </div>
          );
        })}
      </div>
      <div className="frc" style={{ justifyContent: "center" }}>
        <button
          className="team-add-work-button"
          disabled={isDisabled || isAdding}
          onClick={handleAddWork}
        >
          {/* {isAdding ? "Adding..." : "Add"} */}
          {isAdding ? "Adding..." : t("Add")}
        </button>
      </div>
    </div>
  );
};

export default AddWork;
